import { Button, Divider, List, ListItem, TextField, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { addSquad, getInviteToken } from '../../data/leagues';

const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'start',
    },
    header: {
        'flex-basis': '100%'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '25ch',
        marginTop: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2),
    },
}));

export function SquadManagement(props) {
    const league = props.league;
    const [showSquadInput, setShowSquadInput] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [inviteLink, setInviteLink] = useState(undefined);
    const [inviteLinkLabel, setInviteLinkLabel] = useState(undefined);
    const onAddSquad = async () => {
        const squadName = document.getElementById('squad-name').value;
        setLoading(true);
        try {
            const data = await addSquad({
                leagueID: props.league.leagueID,
                squadName: squadName,
                players: [],
            });
            setError(undefined);
            props.refresh();
        } catch (e) {
            setError(`Failed to add squad - ${e}`);
        }
        setLoading(false);
    };
    const onCancel = () => {
        setShowSquadInput(false);
        setError(undefined);
    };
    const onInviteClick = async (squadName) => {
        const data = {
            leagueID: props.league.leagueID,
            type: 'squad',
            squadName: squadName,
        };
        try {
            const response = await getInviteToken(data);
            const inviteLink = `${window.location.protocol}//${window.location.host}${response.url}`;
            setInviteLink(inviteLink);
            setInviteLinkLabel(squadName);
            navigator.clipboard.writeText(inviteLink);
            setError(undefined);
        } catch (e) {
            setError(`Failed to get invite token - ${e}`);
            setInviteLink(undefined);
        }
    };
    const onAdminInviteClick = async () => {
        const data = {
            leagueID: props.league.leagueID,
            type: 'admin',
        };
        try {
            const response = await getInviteToken(data);
            const inviteLink = `${window.location.protocol}//${window.location.host}${response.url}`;
            setInviteLink(inviteLink);
            setInviteLinkLabel('ADMIN');
            navigator.clipboard.writeText(inviteLink);
            setError(undefined);
        } catch (e) {
            setError(`Failed to get invite token - ${e}`);
            setInviteLink(undefined);
        }
    }
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {error &&
                <div style={{ flexBasis: '100%', alignSelf: 'start', textAlign: 'left', margin: 5 }}>
                    <Alert severity="error">
                        <AlertTitle>Server Error</AlertTitle>
                        {error}
                    </Alert>
                </div>
            }
            {inviteLink &&
                <div style={{ flexBasis: '100%', alignSelf: 'start', textAlign: 'left', margin: 5 }}>
                    <Alert severity="success">
                        <AlertTitle>Invite Link</AlertTitle>
                        Invite <a href={inviteLink}>link</a> for {inviteLinkLabel} copied to clipboard!
                    </Alert>
                </div>
            }
            <Button variant="contained" style={{ marginLeft: 10 }} onClick={() => onAdminInviteClick()}>
                Generate Admin Invite
            </Button>
            <Divider style={{ marginTop: 20 }} />
            <Typography variant="h6" component="h6" className={classes.header}>
                Current Squads
            </Typography>
            <List>
                {league.teams.map((team, i) => (
                    <ListItem key={i}>
                        <EditOutlinedIcon disabled style={{ marginRight: 10, display: 'none' }} />
                        <div style={{ minWidth: 200 }}>{team.name}</div>
                        <Button variant="contained" style={{ marginLeft: 10 }}
                            onClick={() => onInviteClick(team.name)}>
                            Invite
                        </Button>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Button className={classes.button} variant="contained" color="primary" onClick={() => setShowSquadInput(true)}>
                Add Squad
            </Button>
            {showSquadInput &&
                <div>
                    <TextField required className={classes.textField} id="squad-name" label="Squad Name" />
                    <Button className={classes.button} variant="contained" color="primary" onClick={() => onAddSquad()}>
                        Save
                    </Button>
                    <Button className={classes.button} variant="contained" color="secondary" onClick={() => onCancel()}>
                        Cancel
                    </Button>
                </div>
            }
        </div>
    )
};